document.addEventListener("DOMContentLoaded", function () {
  let selectedVariantId = null;

  /* =========================================================
     SIZE SELECTOR
  ========================================================= */

  const sizeButtons = document.querySelectorAll(".betulla-size-button");

  sizeButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      selectedVariantId = button.getAttribute("data-variant-id");

      sizeButtons.forEach(function (btn) {
        btn.classList.remove("active");
      });

      button.classList.add("active");
    });
  });


  /* =========================================================
     SINGLE VARIANT FALLBACK
     Per prodotti senza taglia: accessori, pouch, wallet ecc.
  ========================================================= */

  const singleVariantInput = document.getElementById("betulla-single-variant-id");

  if (singleVariantInput) {
    selectedVariantId = singleVariantInput.value;
  }


  /* =========================================================
     SIZE DRAWER
  ========================================================= */

  const openSizeButton = document.querySelector("[data-betulla-open-size]");
  const closeSizeButtons = document.querySelectorAll("[data-betulla-close-size]");
  const sizeOverlay = document.getElementById("betulla-size-overlay");
  const sizeDrawer = document.getElementById("betulla-size-drawer");

  function openSizeDrawer() {
    if (!sizeOverlay || !sizeDrawer) return;

    sizeOverlay.style.display = "block";
    sizeDrawer.style.display = "block";
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }

  function closeSizeDrawer() {
    if (!sizeOverlay || !sizeDrawer) return;

    sizeOverlay.style.display = "none";
    sizeDrawer.style.display = "none";
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  }

  if (openSizeButton) {
    openSizeButton.addEventListener("click", openSizeDrawer);
  }

  closeSizeButtons.forEach(function (button) {
    button.addEventListener("click", closeSizeDrawer);
  });


  /* =========================================================
     ADD TO CART
     Aggiunge il prodotto e prova ad aprire il cart drawer Shopify.
  ========================================================= */

  const addCartButton = document.getElementById("betulla-add-cart");
  const cartMessage = document.getElementById("betulla-cart-message");

  if (addCartButton) {
    addCartButton.addEventListener("click", function () {
      if (!selectedVariantId) {
        if (cartMessage) {
          cartMessage.innerHTML = "Seleziona una taglia.";
        }
        return;
      }

      addCartButton.innerHTML = "AGGIUNGO...";
      addCartButton.disabled = true;

      if (cartMessage) {
        cartMessage.innerHTML = "";
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: Number(selectedVariantId),
          quantity: 1
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Errore aggiunta carrello");
          }

          return response.json();
        })
        .then(function () {
          return fetch("/cart?sections=cart-drawer,cart-icon-bubble");
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (sections) {
          const cartDrawer = document.querySelector("cart-drawer");

          if (sections["cart-drawer"] && cartDrawer) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections["cart-drawer"], "text/html");
            const newDrawer = doc.querySelector("cart-drawer");

            if (newDrawer) {
              cartDrawer.innerHTML = newDrawer.innerHTML;
            }
          }

          if (sections["cart-icon-bubble"]) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections["cart-icon-bubble"], "text/html");
            const newBubble = doc.querySelector("#cart-icon-bubble");
            const oldBubble = document.querySelector("#cart-icon-bubble");

            if (newBubble && oldBubble) {
              oldBubble.innerHTML = newBubble.innerHTML;
            }
          }

          if (cartDrawer && typeof cartDrawer.open === "function") {
            cartDrawer.open();
          } else {
            window.location.href = "/cart";
          }

          addCartButton.innerHTML = "AGGIUNGI AL CARRELLO";
          addCartButton.disabled = false;
        })
        .catch(function (error) {
          console.error(error);

          if (cartMessage) {
            cartMessage.innerHTML = "Errore. Riprova.";
          }

          addCartButton.innerHTML = "AGGIUNGI AL CARRELLO";
          addCartButton.disabled = false;
        });
    });
  }


  /* =========================================================
     PRODUCT GALLERY DOTS / DESKTOP CLICK
     Mobile: swipe naturale.
     Desktop: click sulle barrette.
  ========================================================= */

  const gallery = document.querySelector(".betulla-product-gallery");
  const dots = document.querySelectorAll(".betulla-slider-dots span");

  if (gallery && dots.length) {
    function updateDots() {
      const slideWidth = gallery.clientWidth;
      if (!slideWidth) return;

      const index = Math.round(gallery.scrollLeft / slideWidth);

      dots.forEach(function (dot, i) {
        dot.classList.toggle("active", i === index);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        gallery.scrollTo({
          left: gallery.clientWidth * index,
          behavior: "smooth"
        });
      });
    });

    gallery.addEventListener("scroll", function () {
      window.requestAnimationFrame(updateDots);
    });

    updateDots();
  }


  /* =========================================================
     ALPHA DIRECT POPUP
  ========================================================= */

  const alphaOpenButton = document.querySelector("[data-alpha-open]");
  const alphaPopup = document.querySelector("[data-alpha-popup]");
  const alphaCloseButtons = document.querySelectorAll("[data-alpha-close]");
  const alphaOverlay = document.querySelector(".betulla-alpha-popup-overlay");

  function openAlphaPopup() {
    if (!alphaPopup || !alphaOverlay) return;

    alphaPopup.classList.add("is-open");
    alphaOverlay.classList.add("is-open");
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }

  function closeAlphaPopup() {
    if (!alphaPopup || !alphaOverlay) return;

    alphaPopup.classList.remove("is-open");
    alphaOverlay.classList.remove("is-open");
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  }

  if (alphaOpenButton) {
    alphaOpenButton.addEventListener("click", openAlphaPopup);
  }

  alphaCloseButtons.forEach(function (button) {
    button.addEventListener("click", closeAlphaPopup);
  });


  /* =========================================================
     PRODUCT TEST MAP
     Se Leaflet o la mappa non ci sono, non fa casino.
     La sezione ora è commentata nel Liquid, quindi normalmente
     questo blocco non parte.
  ========================================================= */

  const mapElement = document.getElementById("betulla-product-map");

  if (mapElement && typeof L !== "undefined") {
    const map = L.map("betulla-product-map", {
      zoomControl: false,
      scrollWheelZoom: false,
      dragging: true,
      attributionControl: true
    });

    L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
      maxZoom: 18,
      attribution: "&copy; OpenStreetMap & Carto"
    }).addTo(map);

    const sheetURL =
      "https://opensheet.elk.sh/1ogg6bGW_g0m-70xflSkFUXcjU7Ea-aEmhT_Ec2BIpjs/Foglio1";

    const bounds = [];

    fetch(sheetURL)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        data.forEach(function (test) {
          if (!test.product || !test.product.toLowerCase().includes("alpha")) return;
          if (!test.lat || !test.lng) return;

          const lat = parseFloat(String(test.lat).replace(",", "."));
          const lng = parseFloat(String(test.lng).replace(",", "."));

          if (Number.isNaN(lat) || Number.isNaN(lng)) return;

          bounds.push([lat, lng]);

          const imageHTML = test.image
            ? `<img src="${test.image}" style="width:100%;height:130px;object-fit:cover;margin-bottom:10px;">`
            : "";

          const popup = `
            <div style="line-height:1.4;min-width:220px;">
              ${imageHTML}
              <strong style="font-size:14px;font-weight:600;">
                ${test.title || ""}
              </strong>
              <br>
              <span style="color:#777;font-size:12px;">
                ${test.temperature || ""}
              </span>
              <br>
              <span style="color:#777;font-size:12px;">
                ${test.activity || ""}
              </span>
              <br><br>
              <span style="font-size:13px;color:#111;">
                ${test.note || ""}
              </span>
            </div>
          `;

          L.circleMarker([lat, lng], {
            radius: 5,
            color: "#111",
            weight: 1,
            fillColor: "#111",
            fillOpacity: 1
          })
            .addTo(map)
            .bindPopup(popup);
        });

        if (bounds.length > 0) {
          map.fitBounds(bounds, {
            padding: [70, 70],
            maxZoom: 6
          });
        }
      })
      .catch(function (error) {
        console.error("Errore Google Sheet:", error);
      });
  }
});